module.exports = __webpack_public_path__ + "img/elburg-n2.169b6a99.jpg";